import React, { useEffect } from "react";
import ScrollToTop from "../components/ScrollToTop";
import about1 from "../images/about1.jpeg";
import about2 from "../images/about2.jpeg";
import about3 from "../images/about3.jpeg";
import about4 from "../images/about4.jpeg";
import about5 from "../images/about5.jpeg";



const About = () => {
	const vh = window.innerHeight / 100;
	useEffect(() => {
		window.scrollTo(0, 12.5 * vh);
	}, []);
	return (
		<section className="about">
			<div className="about-head">
				<span className="about-head-head">About MEC</span>
			</div>
			<div className="about-body">
				<div className="about-body-container">
					<div className="about-body-image">
						<img
							className="about-body-image__img"
							src={about1}
							alt="About aavesh"
						/>
					</div>
					<div className="about-body-content">
					Muthayammal Engineering College, an Autonomous Institution 
					affiliated to Anna University, Chennai, was established in the year 2000 under the aegis of Muthayammal Educational Trust and Research Foundation with the motto to uplift the rural community through Technical Education. The College has grown as a reputed Institution in the past 20 years and progressing with the aim to become Centre of Excellence in Engineering Education, Research and Development
				
					</div>
				</div>
				<div className="about-body-container">
					<div className="about-body-image">
						<img
							className="about-body-image__img"
							src={about2}
							alt="About aavesh"
						/>
					</div>
					<div className="about-body-content">
						We organize various expert lectures, workshops,
						mentorship programs as well as competitions throughout
						the year with the aim of keeping the students learning
						and providing them the necessary resources to implement
						their ideas.
					</div>
				</div>
			</div>
			<div className="about-head">
				<span className="about-head-head">About SYMCOSCI:</span>
			</div>
			<div className="about-body">
				<div className="about-body-container">
					<div className="about-body-image">
						<img
							className="about-body-image__img"
							src={about4}
							alt="About SYMCOSCI:"
						/>
					</div>
					<div className="about-body-content">
						Sympcosci where creativity, innovation, passion and
						social responsibility converge.  A National Level Technical
						Symposium organized by the Department of Computer Science and Engineering,
						pulsates with vitality.  Symcosci offers a spectrum of experience 
						from an array of technical and non-technical events, every facet resonates with innovation
						and purpose.
					</div>
				</div>
				<div className="about-body-container">
					<div className="about-body-image">
						<img
							className="about-body-image__img"
							src={about3}
							alt="About TECHतत्त्व:"
						/>
					</div>
					<div className="about-body-content">
						It is an avenue to be comforted from the routine life
						and to embrace the fun. Planned as a ‘for the students,
						of the students, by the students’ event, the festival is
						the most awaited event of the year.
					</div>
				</div>
				<div className="about-body-container">
					<div className="about-body-image">
						<img
							className="about-body-image__img"
							src={about5}
							alt="About TECHतत्त्व:"
						/>
					</div>
					<div className="about-body-content">
						To promote Science, Technology, Engineering and
						Mathematics (STEM) activities to young people and the
						wider community.
						<ul
							style={{
								fontSize: "1rem",
								lineHeight: "1.25rem",
							}}
						>
							<li>
								A quality inclusive working environment which is
								responsive to a member's voice
							</li>
							<li>
								Learning from the past mistakes and working
								together as a team for the betterment of the
								institution.{" "}
							</li>
							<li>
								Setting an ideal "benchmark” for the coming year
								students regarding managing vital events of our
								institute.
							</li>
						</ul>
					</div>
				</div>
			</div>
			<ScrollToTop />
		</section>
	);
};

export default About;
